import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import '../DataModal/DataModal.styles.scss';

interface DataTableSkeletonProps {
  columns: Array<{ header: string; width?: string }>;
  rowCount?: number;
}

const DataTableSkeleton: React.FC<DataTableSkeletonProps> = ({ columns, rowCount = 6 }) => {
  return (
    <table className="data-table">
      <thead>
        <tr>
          {columns.map((column, index) => (
            <th key={index} style={{ width: column.width }}>
              {column.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rowCount }).map((_, rowIndex) => (
          <tr key={rowIndex}>
            {columns.map((column, colIndex) => (
              <td key={colIndex}>
                <Skeleton width="90%" height="1.5rem" />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DataTableSkeleton;
